// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","702":"querybridge","945":"dashboard"}[chunkId] || chunkId) + "." + {"317":"87086a9d","594":"cb562b0a","702":"8bb6b159","945":"720bdb66"}[chunkId] + ".js";
};